import React, { useEffect, useRef } from "react";
import ChatMessage from "./ChatMessage";

export default function MessageList({ messages, streaming }) {
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [messages]);

  const lastIndex = messages.length - 1;

  return (
    <div
      ref={scrollRef}
      className="flex-1 overflow-y-auto p-6 font-mono text-sm leading-relaxed space-y-5"
    >
      {messages.map((m, i) => (
        <ChatMessage
          key={m.id}
          message={m}
          isStreaming={streaming && i === lastIndex}
          testid={`ai-message-${i}`}
        />
      ))}
    </div>
  );
}
